import { Component, Vue, Prop } from "vue-property-decorator";
import DownloadDocument from "@/components/DownloadDocument.vue";
import { matCancel, matArrowDropDown } from "@quasar/extras/material-icons";
import { Option } from "@/models/Option";
import { decodeHtml } from "@/utils/decodeHtml";
import { DocumentFile } from './../models/DocumentFile';
import { bus } from "../main";
import busEvents from "@/bus/busEvents"; 
import { DynamicFile } from "@/models/DownloadDocument/DynamicFile";
import Loader from "@/components/utils/Loader.vue"
import { downloadFile } from "@/utils/download";
declare const window: any;

@Component({
  components: {
    DownloadDocument,
    Loader
  }
})
export default class ProductDownloads extends Vue {
  @Prop() private language!: string;
  private CONFIG: any = undefined;
  private TRANSLATIONS: any = undefined;
  private selectedSubType: any = "";
  private selectedProductFamily = "";
  private selectedProductName = "";
  private matCancel: string | undefined;
  private matArrowDropDown: string | undefined;
  private sharedFilteredData: Array<any> = [];
  private productFamilyArray: Array<Option> = [];
  private productNameArray: Array<any> = [];

  public store = this.$store.direct;

  public created() {
    this.store.dispatch.appStateModule.setLanguage({ language: this.language})
    this.CONFIG = window["DOCUMENTS"];
    this.TRANSLATIONS = window["DOCUMENTS_TRANSLATIONS"];
    this.matCancel = matCancel;
    this.matArrowDropDown = matArrowDropDown;

    if (this.CONFIG.Types) {
      const selected = (this.subTypes as Array<any>).find(
        x => x.selected === true
      );
      if (selected) {
        this.selectedSubType = selected.value;
      }
    }
  }

  private get subTypes(): Array<any> {
    const subTypes: Array<Option> = [];

    if (this.CONFIG.Types) {
      this.CONFIG.Types.forEach((x: any) => {
        subTypes.push(x);
      });
    }

    return subTypes.map(subType => {
      return {
        label: subType.Label,
        value: subType.Value,
        selected: subType.Selected
      };
    });
  }

  private Visible(subType: string): any {
    if (this.selectedSubType) {
      if (subType !== this.selectedSubType) return false;
    }
    return true;
  }
  private clearInputs(): any {
    this.selectedProductName = "";
    this.selectedProductFamily = "";
  }

  private SubTypeFiles(subType: string): any {
    return (this.filteredAndGroupedBySubType as any)[subType];
  }

  private get filteredAndGroupedBySubType(): object {
    const filter = (x: any): boolean => {
      if (this.selectedSubType) {
        if (x.Subtype !== this.selectedSubType) return false;
      }
      return true;
    };

    const getGroupedFiles = function(files: Array<any>): any {
      const map = new Map();
      files.forEach(file => {
        if (filter(file)) {
          const key = file.Subtype;
          const collection = map.get(key);
          if (!collection) {
            map.set(key, [file]);
          } else {
            collection.push(file);
          }
        }
      });
      return Array.from(map).reduce((obj: any, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
    };

    const correctedFiles = this.CONFIG.Files.map((file: DocumentFile) => {
      file.Description = decodeHtml(file.Description);
      return file;
    });

    const filesGrouped = getGroupedFiles(correctedFiles);
    this.sharedFilteredData = filesGrouped;
    if (this.selectedSubType) {
      this.productFamilyArray = this.extractProductFamily(filesGrouped);
    }
    if (this.selectedProductName) {
      const filteredGroup = filesGrouped;
      filteredGroup[this.selectedSubType] = this.getFilesForSubType(filesGrouped).filter((x: any) =>
        x.IncludedProductNames.includes(this.selectedProductName)
      );
      return filteredGroup;
    } 
    if (this.selectedProductFamily) {
      const filteredGroup = filesGrouped;
      filteredGroup[this.selectedSubType] = this.getFilesForSubType(filesGrouped).filter((x: any) =>
        x.IncludedProductFamilies.includes(this.selectedProductFamily)
      );
      return filteredGroup;
    }
    return filesGrouped;
  }

  private updateProductNames(): any {
    this.selectedProductName = "";
    const familyProducts = this.CONFIG.Products[this.selectedProductFamily]
    const filteredData: DocumentFile[] = this.CONFIG.Files.filter(
      (x: DocumentFile) => x.Subtype === this.selectedSubType && x.IncludedProductFamilies.includes(this.selectedProductFamily)
    );
    //compare all product within family with products that are included within files
    //next flatten structure (reduce) to get one array of strings
    const productsToInclude = filteredData.map(f => f.IncludedProductNames.filter(p => familyProducts.includes(p)))
                                          .reduce((acc, element) => [...acc, ...element], [])
    this.productNameArray = Array.from(new Set(productsToInclude)).map(family => ({
      label: family,
      value: family,
      selected: false
    }))
  }

  private updateCurrentDataTable(): any {
    this.SubTypeFiles(this.selectedSubType);
  }

  private extractProductFamily(files: any): any[] {
    const filesOfType = this.getFilesForSubType(files);
    const flattenFamilies = filesOfType.map(f => f.IncludedProductFamilies)
                                       .reduce((acc, next) => acc.concat(next), [])
    const distinctedFamilies = Array.from(new Set<string>(flattenFamilies));
    return distinctedFamilies.map(family => ({
      label: family,
      value: family,
      selected: false
    }))
  }

  private compare = function(a: any, b: any) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  };

  private GetTypeLabel(value: string): string {
    const tmp = this.subTypes.find((x: { value: string }) => x.value == value);
    return tmp.label;
  }

  private Translate(text: string): string {
    if (this.TRANSLATIONS && this.TRANSLATIONS[text]) {
      return this.TRANSLATIONS[text];
    }
    return text;
  }

  private getFilesForSubType(files: any): Array<DocumentFile> {
    return files[this.selectedSubType] as Array<DocumentFile>;
  }

  public downloadDynamicFile(data: any) {
    const fileData = this.mapFileToDynamicFile({...data, callback: (filepath: string) => downloadFile(data.Name, filepath)})
    bus.$emit(busEvents.DOWNLOAD_DYNAMIC_DOCUMENT, fileData)
  }

  private mapFileToDynamicFile(data: any): DynamicFile {
    const castedFile = {
      id: data.Id,
      name: data.Name,
      templateName: data.DynamicFileAttributes.templateName,
      tags: data.DynamicFileAttributes,
      callback: data.callback
    } as DynamicFile
    return castedFile;
  }

}
